import { Tooltip, Typography } from '@mui/material';

type Props = {
    url: string;
};

// The url of an uploaded file, shown rather than edited. An S3 url is long, so it truncates into
// its tooltip.
export default function AssetUrlText({ url }: Props) {
    return (
        <Tooltip title={url}>
            <Typography
                variant="body2"
                color="text.secondary"
                noWrap
                sx={{ flex: 1, minWidth: 0 }}
                // Read by a screen reader, which gets nothing from a truncated hash.
                aria-label={`File address: ${url}`}
            >
                {url}
            </Typography>
        </Tooltip>
    );
}
